import { hasApiMenuPermission } from '@/libs/permissions';

// 通过 computed 计算属性，获取权限
// 当前模块使用过的权限，全部集中在这里，方便查看和维护
export default {
  computed: {
    // 权限 - 站点
    AUTH_SITE() {
      return hasApiMenuPermission('and', ['auth_site', 'auth_site_list']);
    },

    // 权限 - 站点 - 添加
    AUTH_SITE_ADD() {
      return hasApiMenuPermission('and', ['auth_site_add']);
    },

    // 权限 - 站点 - 编辑
    AUTH_SITE_EDIT() {
      return hasApiMenuPermission('and', ['auth_site_edit']);
    },

    // 权限 - 站点 - 删除
    AUTH_SITE_DELETE() {
      return hasApiMenuPermission('and', ['auth_site_delete']);
    },

    // 权限 - 站点 - 详情
    AUTH_SITE_DETAIL() {
      return hasApiMenuPermission('and', ['auth_site_detail']);
    },

    // 权限 - 站点 - 详情 - 设备
    AUTH_SITE_DETAIL_TAB_DEVICE() {
      return hasApiMenuPermission('and', [
        'auth_site_detail_device',
        'auth_site_detail_device_list',
      ]);
    },

    // 权限 - 站点 - 详情 - 故障
    AUTH_SITE_DETAIL_TAB_FAULT() {
      return hasApiMenuPermission('and', ['auth_site_detail_fault']);
    },

    // 权限 - 站点 - 详情 - 事件
    AUTH_SITE_DETAIL_TAB_EVENT() {
      return hasApiMenuPermission('and', ['auth_site_detail_event']);
    },

    // 权限 - 站点 - 详情 - 设备模型
    AUTH_SITE_DETAIL_MODEL_CATEGORY() {
      return hasApiMenuPermission('and', ['auth_site_device_model_category']);
    },

    // 权限 - 站点 - 详情 - 状态统计
    AUTH_SITE_DETAIL_STATUS_STATISTICS() {
      return hasApiMenuPermission('and', ['auth_site_status_statistics']);
    },

    // 权限 - 站点 - 详情 - 流量统计
    AUTH_SITE_DETAIL_TRAFFIC_STATISTICS() {
      return hasApiMenuPermission('and', ['auth_site_traffic_statistics']);
    },

    // 权限 - 站点 - 详情 - 流量累计
    AUTH_SITE_DETAIL_TRAFFIC_ACCUMULATION() {
      return hasApiMenuPermission('and', ['auth_site_traffic_accumulation']);
    },

    // 权限 - 站点 - 详情 - 管理员列表
    AUTH_SITE_ADMIN_LIST() {
      return hasApiMenuPermission('and', ['auth_site_admin_list']);
    },

    // 权限 - 站点 - 详情 - 用户
    AUTH_USER_DETAIL() {
      return hasApiMenuPermission('and', ['auth_user', 'auth_user_list', 'auth_user_detail']);
    },

    // 权限 - 站点 - 详情 - 客户
    AUTH_CUSTOMER_DETAIL() {
      return hasApiMenuPermission('and', ['auth_customer_detail']);
    },

    // 权限 - 站点 - 详情 - 设备 - 批量导入
    AUTH_SITE_DETAIL_DEVICE_BATCH_IMPORT() {
      return hasApiMenuPermission('and', ['auth_site_detail_device_batch_import']);
    },

    // 权限 - 站点 - 详情 - 故障 - 当前故障
    AUTH_SITE_FAULT_CURRENT() {
      return hasApiMenuPermission('and', ['auth_site_fault_current']);
    },

    // 权限 - 站点 - 详情 - 故障 - 历史故障
    AUTH_SITE_FAULT_HISTORY() {
      return hasApiMenuPermission('and', ['auth_site_fault_history']);
    },

    // 权限 - 站点 - 详情 - 事件 - 设备控制事件
    AUTH_SITE_EVENT_DEVICE_CONTROL() {
      return hasApiMenuPermission('and', ['auth_site_event_device_control']);
    },

    // 权限 - 站点 - 详情 - 事件 - 设备操作事件
    AUTH_SITE_EVENT_DEVICE_OPERATION() {
      return hasApiMenuPermission('and', ['auth_site_event_device_operation']);
    },

    // 权限 - 站点 - 详情 - 事件 - 设备配置事件
    AUTH_SITE_EVENT_DEVICE_CONFIG() {
      return hasApiMenuPermission('and', ['auth_site_event_device_config']);
    },

    // 权限 - 站点 - 详情 - 事件 - 站点操作事件
    AUTH_SITE_EVENT_SITE_OPERATION() {
      return hasApiMenuPermission('and', ['auth_site_event_site_operation']);
    },
  },
};
